import React, { ReactElement } from "react";
import styled from "styled-components";
import { Li } from "./Li";

type UlProps = {
  children: ReactElement<typeof Li> | ReactElement<typeof Li>[];
};

export const Ul = ({ children }: UlProps) => {
  return <StyledUl>{children}</StyledUl>;
};

const StyledUl = styled.ul`
  padding-left: 2rem;
  list-style-type: disc;
  ul {
    list-style-type: circle;
    ul {
      list-style-type: square;
    }
  }
`;
